import {
    createRouter,
    createWebHistory
} from 'vue-router';

import DoctorRegister from "../views/DoctorRegister/DoctorRegister.vue"
import DoctorHome from "../views/DoctorHome/DoctorHome.vue"

import IndexHome from "../views/Index/index.vue"

import PatientHome from "../views/PatientHome/PatientHome.vue"
import ReferralPatientForm from '../views/ReferralPatientForm/ReferralPatientForm.vue';
const routes = [
    // {
    //     path: '/',
    //     name: 'DoctorRegister',
    //     component: DoctorRegister

    // },

    {
        path: '/',
        name: 'IndexHome',
        component: IndexHome

    },

    {
        path: '/patienthome',
        name: 'PatientHome',
        component: PatientHome

    },
    {
        path: '/doctorregister',
        name: 'DoctorRegister',
        component: DoctorRegister

    },
    {
        path: '/doctorhome',
        name: 'DoctorHome',
        component: DoctorHome,
        meta: {
            requiresAuth: true, // 需要登录才能访问
        },

    },
    {
        path: '/referral-patient',
        name: 'ReferralPatient',
        component: ReferralPatientForm,
        meta: {
            requiresAuth: true, // 需要登录才能访问
        },

    }

];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;